module.exports = __webpack_public_path__ + "images/icon-app.png?a4626213f788ed5bb5bcb5e525cda796";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/icon-app.png
// module id = 994
// module chunks = 0